import { cn } from '../../lib/utils'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select'

export interface FilterControlsProps {
  statusFilter: string
  chainFilter: string
  onStatusFilterChange: (value: string) => void
  onChainFilterChange: (value: string) => void
  statusOptions: Array<{ value: string; label: string }>
  chainOptions: Array<{ value: string; label: string }>
  className?: string
}

export function FilterControls({
  statusFilter,
  chainFilter,
  onStatusFilterChange,
  onChainFilterChange,
  statusOptions,
  chainOptions,
  className = '',
}: FilterControlsProps) {
  return (
    <div className={cn('flex items-center gap-2', className)}>
      <span className=" ml-4 text-sm font-medium text-card-text leading-none hidden md:inline-block">
        Filter:
      </span>
      <Select value={statusFilter} onValueChange={onStatusFilterChange}>
        <SelectTrigger className="w-[140px] bg-white">
          <SelectValue placeholder="All Status" />
        </SelectTrigger>
        <SelectContent>
          {statusOptions.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <Select value={chainFilter} onValueChange={onChainFilterChange}>
        <SelectTrigger className="w-[120px] bg-white">
          <SelectValue placeholder="All Chains" />
        </SelectTrigger>
        <SelectContent>
          {chainOptions.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
